import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface LoyaltyProgram {
  id: string;
  name: string;
  nameAr: string;
  logo: string;
  color: string;
}
interface LoyaltyProgramModalProps {
  isOpen: boolean;
  onClose: () => void;
  program: LoyaltyProgram;
  onPointsApplied: (program: string, amount: number) => void;
}
export function LoyaltyProgramModal({
  isOpen,
  onClose,
  program,
  onPointsApplied
}: LoyaltyProgramModalProps) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [selectedMethod, setSelectedMethod] = useState<'phone' | 'account'>('phone');
  const [step, setStep] = useState<'input' | 'verify'>('input');
  const [verificationCode, setVerificationCode] = useState('');
  const [availablePoints, setAvailablePoints] = useState(0);
  const [pointsToUse, setPointsToUse] = useState('');
  if (!isOpen) return null;
  const handleSendCode = () => {
    setAvailablePoints(5000);
    setStep('verify');
  };
  const handleApplyPoints = () => {
    const points = parseFloat(pointsToUse);
    if (points > 0 && points <= availablePoints) {
      onPointsApplied(program.id, points);
      onClose();
    }
  };
  const getInstructions = () => {
    switch (program.id) {
      case 'qitaf':
        return 'Enter Qitaf registered mobile number';
      case 'tamayouz':
        return 'Please enter STC Tamayouz phone number';
      case 'mokafaa':
        return 'Enter your phone number or your account number to redeem your points';
      default:
        return 'Enter your details to use points';
    }
  };
  const isInputValid = () => {
    if (program.id === 'mokafaa' || program.id === 'tamayouz') {
      return phoneNumber.trim() !== '';
    }
    return selectedMethod === 'phone' ? phoneNumber.trim() !== '' : accountNumber.trim() !== '';
  };
  return <>
      {/* Desktop Modal */}
      <div className="hidden md:block fixed inset-0 z-[60] overflow-y-auto" data-id="element-1813" data-mp="13fc685dyipu1">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-1814" data-mp="361hkgxs2jb2q"></div>
        <div className="flex min-h-full items-center justify-center p-4" data-id="element-1815" data-mp="319q2vcqw4foq">
          <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1816" data-mp="2wbeqovd4ht3c">
            <div className="flex items-center justify-between mb-4" data-id="element-1817" data-mp="2rclfxap80g6v">
              <h2 className="text-xl font-bold" data-id="element-1818" data-mp="2reelsns0ewdt">
                Use Points - {program.nameAr}
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-1819" data-mp="3oxzk01d5sf9j">
                <XIcon className="w-6 h-6" data-id="element-1820" data-mp="3f1moqz1yttco" />
              </button>
            </div>
            {step === 'input' ? <>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1821" data-mp="3b014utr0kesz">
                  {getInstructions()}
                </p>
                {program.id === 'mokafaa' || program.id === 'tamayouz' ?
            // Mokafaa and Tamayouz: Single phone number input field
            <div className="mb-4" data-id="element-1822" data-mp="f464kx9q4yte">
                    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden" data-id="element-1823" data-mp="f1a4b2aely1s">
                      <div className="bg-gray-50 px-3 py-2 border-r border-gray-300 flex items-center gap-2" data-id="element-1824" data-mp="j2vlv0xvv0ib">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1825" data-mp="surnun33bart" />
                        <span className="text-sm font-medium" data-id="element-1826" data-mp="12re7x9nldxss">+966</span>
                      </div>
                      <input type="tel" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder={program.id === 'mokafaa' ? 'Phone number or account number' : '530151938'} className="flex-1 px-3 py-2 focus:outline-none" data-id="element-1827" data-mp="16v2j02bfnbis" />
                    </div>
                  </div> :
            // Other programs: Keep existing radio button logic
            <>
                    <div className="space-y-3 mb-4" data-id="element-1828" data-mp="2n9dkk1376gj7">
                      <label className="flex items-center border-2 border-gray-200 rounded-lg p-3 cursor-pointer hover:border-[#1E2B55] transition-colors" data-id="element-1829" data-mp="2n7u4oblge7hy">
                        <input type="radio" name="method" checked={selectedMethod === 'phone'} onChange={() => setSelectedMethod('phone')} className="mr-3" data-id="element-1830" data-mp="1umas9qp4721e" />
                        <div className="flex items-center gap-2 flex-1" data-id="element-1831" data-mp="1gsjrp7td2sht">
                          <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1832" data-mp="1bvjmez4c5trr" />
                          <span className="text-sm" data-id="element-1833" data-mp="3djxnykcq784d">+966</span>
                        </div>
                      </label>
                      <label className="flex items-center border-2 border-gray-200 rounded-lg p-3 cursor-pointer hover:border-[#1E2B55] transition-colors" data-id="element-1834" data-mp="3iih587gdjvqe">
                        <input type="radio" name="method" checked={selectedMethod === 'account'} onChange={() => setSelectedMethod('account')} className="mr-3" data-id="element-1835" data-mp="a148u34aub83" />
                        <span className="text-sm text-gray-600" data-id="element-1836" data-mp="2lsrhznabqg76">
                          Account number
                        </span>
                      </label>
                    </div>
                    {selectedMethod === 'phone' ? <div className="mb-4" data-id="element-1837" data-mp="wab1pyzsibg0">
                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden" data-id="element-1838" data-mp="wdgr7fcbzfc9">
                          <div className="bg-gray-50 px-3 py-2 border-r border-gray-300 flex items-center gap-2" data-id="element-1839" data-mp="mlt2vnb2mef0">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1840" data-mp="hn9ktxzllmrx" />
                            <span className="text-sm font-medium" data-id="element-1841" data-mp="3moyiruh58to">+966</span>
                          </div>
                          <input type="tel" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder="530151938" className="flex-1 px-3 py-2 focus:outline-none" data-id="element-1842" data-mp="3utrqvmm1tl5h" />
                        </div>
                      </div> : <div className="mb-4" data-id="element-1843" data-mp="25j66mnu2u39n">
                        <input type="text" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} placeholder="Enter account number" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1844" data-mp="2ab7ezyo4j9ue" />
                      </div>}
                  </>}
                <button onClick={handleSendCode} disabled={!isInputValid()} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium hover:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1845" data-mp="1wjj6s6gzx5ip">
                  {program.id === 'mokafaa' ? 'Send code' : 'Next'}
                </button>
              </> : <>
                <div className="mb-4" data-id="element-1846" data-mp="3p2zv465ievh9">
                  <p className="text-sm text-gray-600 mb-2" data-id="element-1847" data-mp="6nfhdhv8gqwf">
                    Available Points:{' '}
                    <span className="font-bold text-[#1E2B55]" data-id="element-1848" data-mp="1wz4byvbr7al">
                      {availablePoints.toLocaleString()}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mb-4" data-id="element-1849" data-mp="gnpw56wx26dp">1 Point = 1 SAR</p>
                </div>
                <div className="mb-4" data-id="element-1850" data-mp="bompxj579u45">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1851" data-mp="pmtdo6gfqdq3">
                    Enter Verification Code
                  </label>
                  <input type="text" value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Enter code" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1852" data-mp="ko03amwg32u5" />
                </div>
                <div className="mb-4" data-id="element-1853" data-mp="16uu9xtf5a6j7">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1854" data-mp="t4h7g6l0vk19">
                    Points to Use
                  </label>
                  <input type="number" value={pointsToUse} onChange={e => setPointsToUse(e.target.value)} placeholder="0" max={availablePoints} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1855" data-mp="x49fmi6i7o63" />
                  <button onClick={() => setPointsToUse(availablePoints.toString())} className="text-xs text-[#1E2B55] hover:underline mt-1" data-id="element-1856" data-mp="e7gl6illoha6">
                    Use all points
                  </button>
                </div>
                <button onClick={handleApplyPoints} disabled={!verificationCode || !pointsToUse} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium hover:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1857" data-mp="2u91vxfwdppcj">
                  Apply Points
                </button>
              </>}
          </div>
        </div>
      </div>
      {/* Mobile Bottom Sheet */}
      <div className="md:hidden fixed inset-0 z-[60]" data-id="element-1858" data-mp="3hzo6bdtuvlpp">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-1859" data-mp="3hx1ydd31z46y"></div>
        <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-xl max-h-[90vh] overflow-y-auto" data-id="element-1860" data-mp="380p2q9ny6g9k">
          <div className="p-4" data-id="element-1861" data-mp="1sjevhbvty0oj">
            <div className="flex items-center justify-between mb-4" data-id="element-1862" data-mp="1smknozzr9ioh">
              <h2 className="text-lg font-bold" data-id="element-1863" data-mp="1wmuswafq452a">
                Use Points - {program.nameAr}
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-1864" data-mp="1p0zbyhkbtqv0">
                <XIcon className="w-6 h-6" data-id="element-1865" data-mp="1z0q62i4z63uk" />
              </button>
            </div>
            {step === 'input' ? <>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1866" data-mp="1u2ook1n76cl7">
                  {getInstructions()}
                </p>
                {program.id === 'mokafaa' || program.id === 'tamayouz' ?
            // Mokafaa and Tamayouz: Single phone number input field
            <div className="mb-4" data-id="element-1867" data-mp="1g1m1blkguw8p">
                    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden" data-id="element-1868" data-mp="1g2nnom6xn55q">
                      <div className="bg-gray-50 px-3 py-2 border-r border-gray-300 flex items-center gap-2" data-id="element-1869" data-mp="1b9ktqcy8ttp0">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1870" data-mp="njqiu0xhif7e" />
                        <span className="text-sm font-medium" data-id="element-1871" data-mp="1cb5urq7cx146">+966</span>
                      </div>
                      <input type="tel" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder={program.id === 'mokafaa' ? 'Phone number or account number' : '530151938'} className="flex-1 px-3 py-2 focus:outline-none" data-id="element-1872" data-mp="1h3z0ohekafhu" />
                    </div>
                  </div> :
            // Other programs: Keep existing radio button logic
            <>
                    <div className="space-y-3 mb-4" data-id="element-1873" data-mp="2eqpk2z57yg40">
                      <label className="flex items-center border-2 border-gray-200 rounded-lg p-3 cursor-pointer active:bg-gray-50" data-id="element-1874" data-mp="2ep4r3dyjz589">
                        <input type="radio" name="method" checked={selectedMethod === 'phone'} onChange={() => setSelectedMethod('phone')} className="mr-3" data-id="element-1875" data-mp="356x5gat5abn" />
                        <div className="flex items-center gap-2 flex-1" data-id="element-1876" data-mp="3gi8w7wu78ruh">
                          <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1877" data-mp="3gg5y0piw7seo" />
                          <span className="text-sm" data-id="element-1878" data-mp="31mj91vda28o6">+966</span>
                        </div>
                      </label>
                      <label className="flex items-center border-2 border-gray-200 rounded-lg p-3 cursor-pointer active:bg-gray-50" data-id="element-1879" data-mp="14qlswtauvh3b">
                        <input type="radio" name="method" checked={selectedMethod === 'account'} onChange={() => setSelectedMethod('account')} className="mr-3" data-id="element-1880" data-mp="17ukmvmpnnx02" />
                        <span className="text-sm text-gray-600" data-id="element-1881" data-mp="12ueziiqf4wns">
                          Account number
                        </span>
                      </label>
                    </div>
                    {selectedMethod === 'phone' ? <div className="mb-4" data-id="element-1882" data-mp="twmklfolzr0x">
                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden" data-id="element-1883" data-mp="f65idu45gx2z">
                          <div className="bg-gray-50 px-3 py-2 border-r border-gray-300 flex items-center gap-2" data-id="element-1884" data-mp="k3x8cil8i94j">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg" alt="SA" className="w-6 h-4 object-cover rounded" data-id="element-1885" data-mp="668nvbv2x400" />
                            <span className="text-sm font-medium" data-id="element-1886" data-mp="3ipl8e82rsure">+966</span>
                          </div>
                          <input type="tel" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder="530151938" className="flex-1 px-3 py-2 focus:outline-none" data-id="element-1887" data-mp="jq28x0ftstb" />
                        </div>
                      </div> : <div className="mb-4" data-id="element-1888" data-mp="jbisijo4gzxc">
                        <input type="text" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} placeholder="Enter account number" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1889" data-mp="f7kwwiy0a791" />
                      </div>}
                  </>}
                <button onClick={handleSendCode} disabled={!isInputValid()} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium active:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1890" data-mp="3r04es9m66z7r">
                  {program.id === 'mokafaa' ? 'Send code' : 'Next'}
                </button>
              </> : <>
                <div className="mb-4" data-id="element-1891" data-mp="dkg9pxvjda8t">
                  <p className="text-sm text-gray-600 mb-2" data-id="element-1892" data-mp="ilm2twt3yziv">
                    Available Points:{' '}
                    <span className="font-bold text-[#1E2B55]" data-id="element-1893" data-mp="2fepa84lvpuq5">
                      {availablePoints.toLocaleString()}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mb-4" data-id="element-1894" data-mp="2csxzn8xoeuvd">1 Point = 1 SAR</p>
                </div>
                <div className="mb-4" data-id="element-1895" data-mp="282rbfa72tcdn">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1896" data-mp="281ppubsfp7ho">
                    Enter Verification Code
                  </label>
                  <input type="text" value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Enter code" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1897" data-mp="1y4bhz0kktr0z" />
                </div>
                <div className="mb-4" data-id="element-1898" data-mp="2hsatidmyt27g">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1899" data-mp="2hr9btqbg1hgr">
                    Points to Use
                  </label>
                  <input type="number" value={pointsToUse} onChange={e => setPointsToUse(e.target.value)} placeholder="0" max={availablePoints} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1900" data-mp="1acea1kk8zj55" />
                  <button onClick={() => setPointsToUse(availablePoints.toString())} className="text-xs text-[#1E2B55] active:underline mt-1" data-id="element-1901" data-mp="2wjk4izcmhclj">
                    Use all points
                  </button>
                </div>
                <button onClick={handleApplyPoints} disabled={!verificationCode || !pointsToUse} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium active:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1902" data-mp="3t9ko8jy4x2vz">
                  Apply Points
                </button>
              </>}
          </div>
        </div>
      </div>
    </>;
}